import { createApp } from "vue";
import "@/styles/global.scss";
import App from "./App.vue";
const vue3App = createApp(App);
import store from "./store";
vue3App.use(store);
import { wxlogin } from "@/utils/initWx.js";
import router from "./router";
import initVant from "@/utils/vant.js";
import "@vant/touch-emulator";

initVant(vue3App);

wxlogin().then(() => {
	vue3App.use(router).mount("#app");
});
